import { gradeTypes } from '$variables/constants';

// convert all grades to integer
const convertStringGradesToInt = (grades) =>
  grades.map(({ grade, ...rest }) => ({ grade: parseInt(grade, 10), ...rest }));

// convert all possible pass/fail values to one kind
const sanitizePassFailGrades = (grades) =>
  grades.map(({ grade, ...rest }) => {
    const lowercaseGrade = (grade || '').toLocaleLowerCase();

    if (lowercaseGrade === 'p' || lowercaseGrade === 'pass') {
      return {
        grade: 'pass',
        ...rest,
      };
    }

    if (lowercaseGrade === 'f' || lowercaseGrade === 'fail') {
      return {
        grade: 'fail',
        ...rest,
      };
    }

    return {
      grade,
      ...rest,
    };
  });

// filter the grades are to be unset
const filterUnsetGrades = (grades) =>
  grades.reduce(
    (allGrades, student) => {
      if (student.grade === '' || student.grade === '-') {
        allGrades.unsetGrades.push({
          ...student,
          grade: null,
        });
        return allGrades;
      }

      allGrades.updatedGrades.push(student);
      return allGrades;
    },
    {
      unsetGrades: [],
      updatedGrades: [],
    }
  );

const sanitizeGrades = ({ grades, gradeType }) => {
  // filter unset grades - or empty
  const { unsetGrades, updatedGrades } = filterUnsetGrades(grades);
  // sanitize percentage grades
  if (gradeType === gradeTypes.percentage) {
    return {
      unsetGrades,
      sanitizedGrades: convertStringGradesToInt(updatedGrades),
    };
  }

  // sanitize pass/fail grades
  if (gradeType === gradeTypes.passFail) {
    return {
      unsetGrades,
      sanitizedGrades: sanitizePassFailGrades(updatedGrades),
    };
  }

  return {
    unsetGrades,
    sanitizedGrades: updatedGrades,
  };
};

export default sanitizeGrades;
